import { SxProps } from '@mui/system'
import { theme } from 'styles-new/mui5-transition/theme'

export const singleSelect: SxProps = {
  height: 48,
  maxWidth: 350,
  margin: 4,
}
